module.exports = __webpack_public_path__ + "img/Trophy Cup Table51.ec7b405d.jpg";